// extracted by mini-css-extract-plugin
export default {"Edit":"Edit_Edit__iwZVH","EditMobile":"Edit_EditMobile__+FOIb","Icon":"Edit_Icon__InZTt"};